import { __extends } from "tslib";
/**
 * Created by Kamil.Adamuszek on 2016-03-22.
 */
import BSSAbstractComponent from '../../bss-abstract-component/js/bss-abstract-component.js';
import template from '../template/dropdown.hbs';
import BSSInfoHintComponent from '../../bss-infohint-component/js/bss-infohint-component.js';
import BSSLabelComponent from '../../bss-label-component/js/bss-label-component.js';
import logger from '@main/externals/bss-package-logger/js/logger';
/**
 * BSSDropdownComponent class
 */
var templateObject = {
    defaultTemplate: template,
};
var _subscriberPrefix = 'component-dropdown-';
var BSSDropdownComponent = /** @class */ (function (_super) {
    __extends(BSSDropdownComponent, _super);
    /**
     *
     * @param {String} [_entityTemplate=null] _entityTemplate entity template
     * @param {String} [containerSelector=null] containerSelector component container selector
     * @param {Object} [config=null] config configuration of component
     * @param {EventManager} [eventManager=null] instance of _EventManager
     * @param {Formatter} [formatter=null] instance of Formatter
     * @param {Resolution} [resolution=null] Resolution class for width breakpoint handling
     * @param {Toolbox} [toolbox=null] instance of Toolbox object
     */
    function BSSDropdownComponent(_entityTemplate, containerSelector, config, eventManager, formatter, resolution, toolbox) {
        if (_entityTemplate === void 0) { _entityTemplate = null; }
        if (containerSelector === void 0) { containerSelector = null; }
        if (config === void 0) { config = null; }
        if (eventManager === void 0) { eventManager = null; }
        if (formatter === void 0) { formatter = null; }
        if (resolution === void 0) { resolution = null; }
        if (toolbox === void 0) { toolbox = null; }
        var _this = this;
        var _a;
        _this = _super.call(this, _entityTemplate, containerSelector, config, eventManager, formatter, resolution, templateObject, toolbox) || this;
        if (_this._config.hintText || _this._config.hintTitle) {
            _this._infohint = new BSSInfoHintComponent(_entityTemplate, '.' + _this._config.componentId + '_info-hint-container', config, eventManager, formatter, resolution, toolbox);
        }
        _this._componentVersion = '@@name ver. @@version';
        logger.info('DropdownComponent:  => constructor : componentId: ' +
            config.componentId +
            ' | Params: ', _entityTemplate, containerSelector, config, eventManager, formatter, resolution, templateObject, logger, toolbox);
        /**
         * @type {null|BSSLabelComponent}
         * @private
         */
        _this._labelComponent = null;
        /**
         * @desc custom dropdown content class
         * @type {string}
         */
        _this._dropdownContentCustomClass = 'bss-dropdown_select-content-custom';
        /**
         * @desc custom dropdown select item class
         * @type {string}
         */
        _this.selectedClass = 'bss-dropdown_select-item--selected';
        /**
         * @desc state of dropdown
         * @type {Boolean}
         */
        _this._isOpen = false;
        /**
         * @desc native select element
         * @type {jQuery|HTMLElement}
         */
        _this._$select = _this._componentScope.find('#' + _this._config.componentId + '_select');
        /**
         * @desc Options list element
         * @type {jQuery|HTMLElement}
         */
        _this._$optionList = null;
        /**
         * @desc custom dropdown selected option
         * @type {HTMLElement}
         */
        _this._customDropdownSelectedOption = null;
        /**
         * @desc binded custom dropdown title text
         * @type {string}
         */
        _this._customDropdownLabel = '';
        /**
         * @desc default dropdown list max height
         * @type {number}
         */
        _this._defaultMaxListHeight = 348;
        _this._checkInjectionType();
        _this._checkDisabled();
        _this._toolbox
            .$('#' + _this._config.componentId)
            .on('change.' + _this._config.componentId, _this._$select, _this._checkDisabled.bind(_this));
        if (_this._config.customSelect) {
            _this._setCustomSelectCommonVars();
        }
        if (_this._config.ifDataConvertToLabel) {
            _this._convertToLabel();
        }
        // checks id dropdown is rendered so we can fire all below dropdown functionality
        // secures situation for ORP OA where dropdowns are converted to labels, they do not exists as dropdowns, so below code should not fire
        if (_this._toolbox.$('#' + _this._config.componentId).length) {
            if (_this._config.customSelect) {
                if (_this._config.externalDictionary &&
                    Object.keys((_a = _this._config) === null || _a === void 0 ? void 0 : _a.externalDictionary)) {
                    _this._bindSelect(_this.selectEl$, _this._config.externalDictionary);
                }
                _this._addCustomEvents();
                if (_this._config.initSelectOnLoad) {
                    _this._eventManager.subscribe('bss-entity-created-' + _this._config.entityInstanceId, _this._initSelectOnLoad.bind(_this), _this.subscriberPrefix + _this._config.componentId);
                }
                else {
                    _this._initCustomSelect();
                }
            }
            _this._eventManager.subscribe('bss-entity-is-shown-' + _this._config.entityInstanceId, _this._checkHidden.bind(_this), _this.subscriberPrefix + _this._config.componentId);
            if (_this._config.createCustomSelectOnEvent) {
                _this._eventManager.subscribe('bss-connector-bind-lookup-select-' + _this._config.entityInstanceId, _this._addOptionList.bind(_this), _this.subscriberPrefix + _this._config.componentId);
            }
        }
        return _this;
    }
    Object.defineProperty(BSSDropdownComponent.prototype, "subscriberPrefix", {
        /**
         * @desc getter of _subscriberPrefix (used for recognizing event relation with the components)
         */
        get: function () {
            return _subscriberPrefix;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * @desc updated dropdown select list after init and after changes selected item
     * @param {Boolean} isUpdated
     * @private
     */
    BSSDropdownComponent.prototype._updateCustomSelectList = function (isUpdated) {
        logger.info('TextInputComponent: ' +
            this._config.componentId +
            ' => function : _getSelectElement');
        this.selectEl =
            this.customSelectContainerEl.getElementsByTagName('select')[0];
        if (isUpdated)
            this._createCustomSelectEl(this.selectEl);
        var newOptionList = this._getNewOptionList(this.selectEl);
        this.customSelectContainerEl.appendChild(newOptionList);
        this._setOptionListCommonVars();
    };
    /**
     * @type {string}
     * @param {HTMLElement} removedElement
     */
    BSSDropdownComponent.prototype._removeDomElement = function (removedElement) {
        logger.info('TextInputComponent: ' +
            this._config.componentId +
            ' => function : _removeDomElement');
        this._componentScope.find(removedElement).remove();
    };
    /**
     * Sets custom select common variables
     * @private
     */
    BSSDropdownComponent.prototype._setCustomSelectCommonVars = function () {
        logger.info('TextInputComponent: ' +
            this._config.componentId +
            ' => function : _setCustomSelectCommonVars');
        this.customSelectEl = document.getElementById("".concat(this._config.componentId, "_custom-select"));
        this.customSelectContainerEl = this._entityTemplate.find("#".concat(this._config.componentId, "_select-container"))[0];
        this.selectEl$ = this._componentScope.find('select');
    };
    BSSDropdownComponent.prototype._addCustomEvents = function () {
        var _this = this;
        logger.info('DropdownComponent: ' +
            this._config.componentId +
            ' => function : _addCustomEvents');
        this._isScrollEventOff = true;
        this._isResizeEventOff = true;
        this._eventManager.subscribe('bss-start-scroll-for-' + this._config.entityInstanceId, this._bindScroll.bind(this), this.subscriberPrefix + this._config.componentId);
        this._eventManager.subscribe('bss-stop-scroll-for-' + this._config.entityInstanceId, this._unbindScroll.bind(this), this.subscriberPrefix + this._config.componentId);
        this._eventManager.subscribe('bss-start-resize-for-' + this._config.entityInstanceId, this._bindResize.bind(this), this.subscriberPrefix + this._config.componentId);
        this._eventManager.subscribe('bss-stop-resize-for-' + this._config.entityInstanceId, this._unbindResize.bind(this), this.subscriberPrefix + this._config.componentId);
        this._eventManager.subscribe('bss-close-dropdown-' + this._config.entityInstanceId, this._closeDropdown.bind(this), this.subscriberPrefix + this._config.componentId);
        this._eventManager.subscribe('bss-unselect-dropdown-' +
            this._config.componentId +
            '-' +
            this._config.entityInstanceId, function (event, target) {
            _this._isOpen = false;
            _this._clickSelect.call(_this, target[0]);
            _this._clickSelect.call(_this, target[0]);
        }, this.subscriberPrefix + this._config.componentId);
    };
    /**
     * @desc create option on event
     * @private
     */
    BSSDropdownComponent.prototype._addOptionList = function () {
        logger.info('DropdownComponent: ' +
            this._config.componentId +
            ' => function : _addOptionList');
        var selectEl = this.customSelectContainerEl.getElementsByTagName('select')[0];
        this._getNewOptionList(selectEl);
        this._setOptionListCommonVars();
    };
    /**
     * Validate insurance component
     * @returns {boolean}
     * @private
     */
    BSSDropdownComponent.prototype._isValid = function () {
        logger.info('BSSInsuranceComponent: ' +
            this._config.componentId +
            ' => function :  _isValid');
        return this._validation.isValid();
    };
    BSSDropdownComponent.prototype._checkInjectionType = function () {
        logger.info('DropdownComponent: ' +
            this._config.componentId +
            ' => function : _checkInjectionType');
        /**
         * @type {boolean}
         * @private
         * @desc describe that simulator is in popup, if this._entity Template has attribute: is-popup - set this value for this parameter
         */
        this._isInPopup = this._entityTemplate.attr('is-popup')
            ? JSON.parse(this._entityTemplate.attr('is-popup'))
            : this._toolbox
                .$('[data-toggle="modal"], .modal-body')
                .has('#' + this._componentScope.attr('id')).length;
        /**
         * @type {jQuery|HTMLElement}
         * @private
         * @desc slideUpContrainer element
         */
        this._slideUpContainer = this._isInPopup
            ? this._entityTemplate
            : this._toolbox.$('.bss-slide-up-layer_content');
        /**
         * @type {jQuery|HTMLElement}
         * @private
         * @desc global window element
         */
        this._globalWindow = null;
        if (this._isInPopup) {
            var classNameBody = this._entityTemplate.attr('data-name-body');
            var classNameContent = this._entityTemplate.attr('data-name-content');
            if (classNameBody) {
                this._globalWindow = this._toolbox.$(classNameBody);
                if (this._toolbox.$(classNameContent) &&
                    !this._toolbox.$(classNameContent).hasClass('modal-dialog')) {
                    this._torPopup = true;
                }
            }
            else {
                this._globalWindow = this._toolbox.$('.modal-body');
            }
        }
        else {
            this._globalWindow = this._window;
        }
    };
    /**
     * @desc bind window scroll event
     * @private
     */
    BSSDropdownComponent.prototype._bindScroll = function () {
        logger.info('DropdownComponent: ' +
            this._config.componentId +
            ' => function : _bindScroll');
        if (this._isScrollEventOff) {
            this._globalWindow.on('scroll.' + this._config.componentId, this._onScroll.bind(this));
            if (!this._isInPopup) {
                this._slideUpContainer.on('scroll.' + this._config.componentId, this._onScroll.bind(this));
            }
            this._isScrollEventOff = false;
        }
    };
    /**
     * Wait until all elements are rendered to the and then initialize a select
     * @private
     */
    BSSDropdownComponent.prototype._initSelectOnLoad = function () {
        var _this = this;
        setTimeout(function () {
            _this._initCustomSelect();
        }, 500);
    };
    /**
     * @desc callback on scroll, tooltips are hidden on scroll
     * @private
     */
    BSSDropdownComponent.prototype._onScroll = function () {
        logger.info('DropdownComponent: ' +
            this._config.componentId +
            ' => function : _onScroll');
        this._closeDropdown();
    };
    /**
     * @desc callback on window resize, hide tooltip
     * @private
     */
    BSSDropdownComponent.prototype._onResize = function () {
        logger.info('DropdownComponent: ' +
            this._config.componentId +
            ' => function : _onResize');
        this._closeDropdown();
    };
    /**
     * @desc bind window scroll event
     * @private
     */
    BSSDropdownComponent.prototype._bindResize = function () {
        logger.info('DropdownComponent: ' +
            this._config.componentId +
            ' => function : _bindResize');
        if (this._isResizeEventOff) {
            this._window.on('resize.' + this._config.componentId, this._onResize.bind(this));
            this._isResizeEventOff = false;
        }
    };
    /**
     * @desc unbind window scroll event
     * @private
     */
    BSSDropdownComponent.prototype._unbindResize = function () {
        logger.info('DropdownComponent: ' +
            this._config.componentId +
            ' => function : _unbindResize');
        this._window.off('resize.' + this._config.componentId);
        this._isResizeEventOff = true;
    };
    /**
     * @desc unbind window scroll event
     * @private
     */
    BSSDropdownComponent.prototype._unbindScroll = function () {
        logger.info('InfohintComponent: ' +
            this._config.componentId +
            ' => function : _unbindScroll');
        this._globalWindow.off('scroll.' + this._config.componentId);
        this._isScrollEventOff = true;
    };
    /**
     * @desc Initialize custom element based on native select element data
     * @private
     */
    BSSDropdownComponent.prototype._initCustomSelect = function () {
        logger.info('DropdownComponent: ' +
            this._config.componentId +
            ' => function : _initCustomSelect');
        this.customDropdown = document.getElementById("".concat(this._config.componentId));
        if (!this.customDropdown.classList.contains('bss-dropdown--is-disabled')) {
            this._updateCustomSelectList(true);
            this.customSelectEl.addEventListener('click', this._clickSelect.bind(this));
            document.addEventListener('click', this._closeDropdown.bind(this));
        }
    };
    /**
     * Set custom dropdown common vars for option list
     * @private
     */
    BSSDropdownComponent.prototype._setOptionListCommonVars = function () {
        logger.info('DropdownComponent: ' +
            this._config.componentId +
            ' => function : _setOptionListCommonVars');
        this._$options = this._componentScope.find(".bss-dropdown_select-items div");
        this._$optionList = this._componentScope.find('.bss-dropdown_select-items');
    };
    /**
     * Create a new DIV that will act as the selected item
     * @param {HTMLElement} selectEl
     * @private
     */
    BSSDropdownComponent.prototype._createCustomSelectEl = function (selectEl) {
        logger.info('DropdownComponent: ' +
            this._config.componentId +
            ' => function : _createCustomSelectEl');
        this._customDropdownLabel = this.customSelectEl.innerHTML;
        this._customDropdownSelectedOption =
            selectEl.options[selectEl.selectedIndex];
        this._addPressedEvent(this.customSelectEl);
    };
    /**
     * Add active(pressed) state for additional 'active' styling
     * @param {Element} el
     * @private
     */
    BSSDropdownComponent.prototype._addPressedEvent = function (el) {
        var _this = this;
        // Start press
        ['mousedown', 'touchstart'].forEach(function (event) {
            el.addEventListener(event, function (_a) {
                var currentTarget = _a.currentTarget;
                _this._$options.removeClass('pressed');
                _this._toolbox.$(currentTarget).addClass('pressed');
            });
        });
        // End press
        ['mouseup', 'touchend'].forEach(function (event) {
            el.addEventListener(event, function (_a) {
                var currentTarget = _a.currentTarget;
                _this._toolbox.$(currentTarget).removeClass('pressed');
            });
        });
    };
    /**
     * For each element, create a new DIV that will contain the option list
     * @param {HTMLElement} selectEl
     * @param selectEl
     * @returns {Element}
     * @private
     */
    BSSDropdownComponent.prototype._getNewOptionList = function (selectEl) {
        logger.info('DropdownComponent: ' +
            this._config.componentId +
            ' => function : _getNewOptionList | Params: ', selectEl);
        var selectedIndex = selectEl.selectedIndex >= 0 ? selectEl.selectedIndex : 0;
        var selectedValue = selectEl.options[selectedIndex].value;
        var newOptionList;
        var $select = this._componentScope.find('.bss-dropdown_select-items');
        if ($select.length) {
            newOptionList = $select[0];
            // Clear all existing options
            newOptionList.innerHTML = '';
        }
        else {
            newOptionList = document.createElement('DIV');
            newOptionList.setAttribute('class', 'bss-dropdown_select-items');
            newOptionList.setAttribute('data-testId', "".concat(this._config.testId, "_custom-custom-select"));
        }
        /* create a new DIV that will contain the option list:*/
        for (var j = 1; j < selectEl.length; j++) {
            /*for each option in the original select element,
                              create a new DIV that will act as an option item:*/
            var _a = selectEl.options[j], value = _a.value, innerHTML = _a.innerHTML, hidden = _a.hidden;
            var newOptionEl = this._getNewOptionEl(value, innerHTML);
            // Add class to identify selected option
            if (value === selectedValue) {
                newOptionEl.classList.add(this.selectedClass);
                // Default and active dropdown states have different styles
                this.customSelectContainerEl.classList.add('bss-dropdown--active');
                // Set default selected option on custom dropdown
                this.customSelectEl.classList.add('selected');
                this._customDropdownSelectedOption = newOptionEl;
            }
            if (hidden) {
                newOptionEl.classList.add('bss-dropdown_select-item--hidden');
            }
            this._addPressedEvent(newOptionEl);
            newOptionList.appendChild(newOptionEl);
        }
        this._changeCustomTitle();
        return newOptionList;
        // }
    };
    /**
     * Create a new optional HTML element based on native select option data
     * @param value
     * @param innerHTML
     * @returns {Element}
     * @protected
     */
    BSSDropdownComponent.prototype._getNewOptionEl = function (value, innerHTML) {
        logger.info('DropdownComponent: ' +
            this._config.componentId +
            ' => function : _getNewOptionEl | Params: ', value, innerHTML);
        var newOptionEl = document.createElement('DIV');
        newOptionEl.setAttribute('customValue', value);
        newOptionEl.setAttribute('data-testId', "".concat(this._config.testId, "_custom-option"));
        newOptionEl.innerHTML = innerHTML;
        newOptionEl.addEventListener('click', this._clickOption.bind(this));
        return newOptionEl;
    };
    /**
     * @desc Handler on select option click
     * @param {Event} el
     * @protected
     */
    BSSDropdownComponent.prototype._clickOption = function (event) {
        logger.info('DropdownComponent: ' +
            this._config.componentId +
            ' => function : _clickOption | Params: ', event);
        this._onClickOption(event);
    };
    /**
     * @desc Set of actions for select option click
     * @param {HTMLElement|Event} el
     * @private
     */
    BSSDropdownComponent.prototype._onClickOption = function (el) {
        logger.info('DropdownComponent: ' +
            this._config.componentId +
            ' => function : _onClickOption | Params: ', el);
        /*when an item is clicked, update the original select box,
                  and the selected item:*/
        var self = el instanceof Event ? el.currentTarget : el;
        var customSelectedValue = self.getAttribute('customvalue');
        var selectEl = self.parentNode.parentNode.getElementsByTagName('select')[0];
        var optionsList = selectEl.options;
        var optionsListLength = optionsList.length;
        //HTMLCollection
        var customOptions = self.parentNode.getElementsByClassName(this.selectedClass);
        this._removeOptionsSelectedClass(customOptions);
        for (var index = 0; index < optionsListLength; index += 1) {
            if (optionsList[index].value === customSelectedValue) {
                selectEl.selectedIndex = index;
                this._customDropdownSelectedOption = self;
                self.setAttribute('class', this.selectedClass);
                break;
            }
        }
        this._clickSelect(el);
        this.customSelectEl.classList.add('selected');
        this.customSelectContainerEl.classList.add('bss-dropdown--active');
        // update dropdown text with selected item
        this._changeCustomTitle();
        // Trigger native select update
        this._$select
            .find("option")
            .removeAttr('selected')
            .filter("[value=".concat(customSelectedValue, "]"))
            .attr('selected', true);
        this._$select.val(customSelectedValue).change();
        this._$select.trigger('change');
    };
    /**
     * Remove selected class from all options
     * @param {HTMLCollection} customOptions
     * @private
     */
    BSSDropdownComponent.prototype._removeOptionsSelectedClass = function (customOptions) {
        logger.info('DropdownComponent: ' +
            this._config.componentId +
            ' => function : _removeOptionsSelectedClass');
        if (customOptions === null || customOptions === void 0 ? void 0 : customOptions.length) {
            for (var _i = 0, customOptions_1 = customOptions; _i < customOptions_1.length; _i++) {
                var customOption = customOptions_1[_i];
                customOption === null || customOption === void 0 ? void 0 : customOption.removeAttribute('class');
            }
        }
    };
    /**
     * @desc Callback on select element click event
     * @param {HTMLElement|Event} el
     * @private
     */
    BSSDropdownComponent.prototype._clickSelect = function (el) {
        logger.info('DropdownComponent: ' +
            this._config.componentId +
            ' => function : _clickSelect | Params: ', el);
        var self = el instanceof Event ? el.currentTarget : el;
        // check open state before close event
        var closed = !this._isOpen;
        this._onSelectCustomDropdownTitle(self);
        // Close other dropdowns before
        this._eventManager.publish('bss-close-dropdown-' + this._config.entityInstanceId, this.subscriberPrefix + this._config.componentId);
        // Close other infohints before (especially the one for a dropdown covering dropdown elements)
        this._eventManager.publish("bss-close-infohints-".concat(this._config.entityInstanceId), this.subscriberPrefix + this._config.componentId);
        if (el instanceof Event) {
            /*when the select box is clicked, close any other select boxes,
                              and open/close the current select box:*/
            el.stopPropagation();
            el.preventDefault();
        }
        if (closed) {
            this._openDropdown();
        }
    };
    /**
     * @desc on select custom dropdown title, when dropdown was opened before and selectErrors is set in ui-desc
     * - clear selected classes, set value to null
     * @param {HTMLElement|Event} el
     * @private
     */
    BSSDropdownComponent.prototype._onSelectCustomDropdownTitle = function (el) {
        logger.info('DropdownComponent: ' +
            this._config.componentId +
            ' => function : _onSelectCustomDropdownTitle | Params: ', el);
        var thisEl = this._componentScope[0];
        var self = el instanceof Event ? el.currentTarget : el;
        if (self == this.customSelectEl &&
            thisEl.classList.contains('open') &&
            this._config.selectErrors) {
            var $self = $(self);
            var customOptions = $self
                .next('.bss-dropdown_select-items')
                .find('.' + this.selectedClass);
            this._removeOptionsSelectedClass(customOptions);
            var selectEl = $self.prev('select')[0];
            selectEl.selectedIndex = null;
            this._customDropdownSelectedOption = null;
            this.customSelectEl.classList.remove('selected');
            this.customSelectContainerEl.classList.remove('bss-dropdown--active');
            this._$select.trigger('change');
        }
    };
    /**
     * @desc calculate top/bottom position of the dropdown option list in window
     * @private
     */
    BSSDropdownComponent.prototype._calculateOptionListPosition = function () {
        var _this = this;
        logger.info('DropdownComponent: ' +
            this._config.componentId +
            ' => function : _calculateOptionListPosition');
        var componentEl = this._componentScope[0];
        var selectEl = this._componentScope.find('.bss-dropdown_select-content-custom')[0];
        var selectElHeight = selectEl.offsetHeight;
        var _a = selectEl.getBoundingClientRect(), componentElTop = _a.top, componentElBottom = _a.bottom;
        var optionListHeight = this._$optionList.outerHeight(true);
        var parentsContainer = this._toolbox.$(this._toolbox.currentEntity.container);
        var parentsContainerTop = parentsContainer[0].getBoundingClientRect().top;
        var windowHeight = this._globalWindow.outerHeight(true);
        var parentsContainerHeight = parentsContainer.outerHeight(true);
        var topClass = 'bss-dropdown-wrapper--top';
        var bottomClass = 'bss-dropdown-wrapper--bottom';
        var minOptionsListHeight = selectElHeight * 2;
        var topOffsetGlobalWindow = componentElTop;
        var topOffsetParentsContainer = componentElTop - parentsContainerTop;
        var topOffset;
        if (topOffsetGlobalWindow >= topOffsetParentsContainer) {
            topOffset = topOffsetParentsContainer;
        }
        else {
            topOffset = topOffsetGlobalWindow;
        }
        topOffset -= 5; // 5px is extra spacing for a better look
        var bottomOffsetGlobalWindow = this._globalWindow.innerHeight() - componentElTop - selectElHeight;
        var bottomOffsetParentsContainer = parentsContainer.innerHeight() +
            parentsContainer.offset().top -
            componentElTop -
            this._window.scrollTop() -
            selectElHeight;
        var bottomOffset;
        var calculationCurrentContainerHeight;
        if (bottomOffsetGlobalWindow >= bottomOffsetParentsContainer) {
            bottomOffset = bottomOffsetParentsContainer;
            calculationCurrentContainerHeight = parentsContainerHeight;
        }
        else {
            bottomOffset = bottomOffsetGlobalWindow;
            calculationCurrentContainerHeight = windowHeight;
        }
        bottomOffset -= 5; // 5px is extra spacing for a better look
        var calculateMaxListHeight = function (maxHeight) {
            if (maxHeight > _this._defaultMaxListHeight) {
                maxHeight = _this._defaultMaxListHeight;
            }
            if (maxHeight <= minOptionsListHeight) {
                maxHeight = _this._config.defaultMaxListHeight
                    ? _this._defaultMaxListHeight
                    : minOptionsListHeight; // Show minimum 2 option list items.
            }
            _this._$optionList.css({ maxHeight: maxHeight });
        };
        if (bottomOffset - optionListHeight <= 0) {
            if (componentElBottom + optionListHeight >=
                calculationCurrentContainerHeight &&
                topOffset > bottomOffset &&
                minOptionsListHeight < topOffset) {
                // position to top
                calculateMaxListHeight(topOffset);
                componentEl.classList.remove(bottomClass);
                componentEl.classList.add(topClass);
            }
            else {
                // calculate if list should have scrollbar and position to down
                componentEl.classList.remove(topClass);
                // If the dropdown contains at least four elements, add padding to keep it inside a container.
                var dropdownLenght = document.getElementById("".concat(componentEl.id, "_select")).length;
                if (dropdownLenght >= 4) {
                    var oldPaddingBottomComponentEl = parseInt(window
                        .getComputedStyle(componentEl)
                        .getPropertyValue('padding-bottom'));
                    componentEl.classList.add(bottomClass);
                    var componentElPaddingValue = parseInt(window
                        .getComputedStyle(componentEl)
                        .getPropertyValue('padding-bottom'));
                    bottomOffset += componentElPaddingValue;
                    bottomOffset -= oldPaddingBottomComponentEl;
                }
                calculateMaxListHeight(bottomOffset);
            }
        }
        else {
            componentEl.classList.remove(topClass);
            componentEl.classList.remove(bottomClass);
        }
    };
    /**
     * @desc calculate top/bottom position of the dropdown option list in popup
     * @private
     */
    BSSDropdownComponent.prototype._calculatePopupOptionListPosition = function () {
        var _this = this;
        logger.info('DropdownComponent: ' +
            this._config.componentId +
            ' => function : _calculatePopupOptionListPosition');
        var componentEl = this._componentScope[0];
        var selectEl = this._componentScope.find('.bss-dropdown_select-content-custom')[0];
        var selectElHeight = selectEl.offsetHeight;
        var componentElTop = selectEl.getBoundingClientRect().top;
        var componentElBottom = selectEl.getBoundingClientRect().bottom;
        var optionListHeight = this._$optionList.outerHeight(true);
        var windowHeight = this._globalWindow.getBoundingClientRect
            ? this._globalWindow.getBoundingClientRect().bottom
            : this._globalWindow.outerHeight(true);
        var topClass = 'bss-dropdown-wrapper--top';
        var $navTabs = this._toolbox.$('#navigationTabs_content');
        var positionNavTabs = $navTabs === null || $navTabs === void 0 ? void 0 : $navTabs.css('position');
        var navTabsHeight = positionNavTabs === 'sticky' || positionNavTabs === 'fixed'
            ? $navTabs.innerHeight()
            : 0;
        var $buttonsContainer = this._toolbox.$(this._entityTemplate.find('.bss-fixed-container')[0]);
        var positionButtonsContainer = $buttonsContainer === null || $buttonsContainer === void 0 ? void 0 : $buttonsContainer.css('position');
        var buttonsContainerHeight = positionButtonsContainer === 'sticky' ||
            positionButtonsContainer === 'fixed'
            ? $buttonsContainer.innerHeight()
            : 0;
        var popupOffset = this._globalWindow[0].getBoundingClientRect();
        var topOffset = componentElTop - popupOffset.top - navTabsHeight - selectElHeight - 5; // 5px is extra spacing for a better look
        var minOptionsListHeight = selectElHeight * 2;
        var bottomOffset = this._globalWindow.innerHeight() -
            buttonsContainerHeight -
            componentElTop +
            popupOffset.top -
            selectElHeight -
            5; // 5px is extra spacing for a better look
        var calculateMaxListHeight = function (maxHeight) {
            if (maxHeight > _this._defaultMaxListHeight) {
                maxHeight = _this._defaultMaxListHeight;
            }
            if (maxHeight <= minOptionsListHeight) {
                maxHeight = minOptionsListHeight; // Show minimum 2 option list items.
            }
            _this._$optionList.css({ maxHeight: maxHeight });
        };
        if (bottomOffset - optionListHeight <= 0) {
            if (componentElBottom + optionListHeight >= windowHeight &&
                topOffset > bottomOffset) {
                // position to top
                calculateMaxListHeight(topOffset);
                componentEl.classList.add(topClass);
            }
            else {
                // calculate if list should have scrollbar and position to down
                componentEl.classList.remove(topClass);
                calculateMaxListHeight(bottomOffset);
            }
        }
        else {
            componentEl.classList.remove(topClass);
        }
    };
    /**
     * @desc open dropdown
     * @private
     */
    BSSDropdownComponent.prototype._openDropdown = function () {
        logger.info('DropdownComponent: ' +
            this._config.componentId +
            ' => function : _openDropdown');
        if (!this._config.leaveCustomDropdownLabel) {
            this.customSelectEl.innerHTML = this._customDropdownLabel;
        }
        this._isOpen = true;
        this._bindScroll();
        this._bindResize();
        var thisEl = this._componentScope[0];
        this._$optionList.css({
            maxHeight: this._defaultMaxListHeight,
        });
        thisEl.classList.toggle('open');
        /**
         * Do not remove selected value on dropdown close action
         * when keepSelectedValue is set to true.
         * Without keepSelectedValue parameter:
         * if user close dropdown without selecting option
         * previously selected value will be removed and user will see title/placeholder.
         */
        if (!this._config.keepSelectedValue &&
            this.customSelectEl.classList.contains('selected')) {
            this.customSelectEl.classList.remove('selected');
        }
        if (this._isInPopup) {
            this._calculatePopupOptionListPosition();
        }
        else {
            this._calculateOptionListPosition();
        }
        this._$select.trigger('focusin');
    };
    /**
     * @desc change title in custom select after closing the dropdown
     * @private
     */
    BSSDropdownComponent.prototype._changeCustomTitle = function () {
        var _a;
        logger.info('DropdownComponent: ' +
            this._config.componentId +
            ' => function : _changeCustomTitle');
        if (this.customSelectEl.classList.contains('selected') ||
            ((_a = this._$options) === null || _a === void 0 ? void 0 : _a.hasClass(this.selectedClass))) {
            this.customSelectEl.innerHTML = "<span class='bss-dropdown_select-label'>".concat(this._customDropdownLabel || '', "</span>\n      <span class='bss-dropdown_selected-option'>").concat(this._customDropdownSelectedOption.innerHTML || '', "</span>");
        }
        else {
            this.customSelectEl.innerHTML = this._customDropdownLabel;
        }
    };
    /**
     * @desc close dropdown
     * @private
     */
    BSSDropdownComponent.prototype._closeDropdown = function () {
        logger.info('DropdownComponent: ' +
            this._config.componentId +
            ' => function : _closeDropdown');
        this._isOpen = false;
        this._unbindScroll();
        this._unbindResize();
        var thisEl = this._componentScope[0];
        this._changeCustomTitle();
        if (thisEl.classList.contains('open')) {
            thisEl.classList.remove('open');
            this._triggerCustomDropdownValidation();
        }
    };
    /**
     * @desc trigger custom dropdown blur for validation only if selectErrors is set in ui-desc
     * @private
     */
    BSSDropdownComponent.prototype._triggerCustomDropdownValidation = function () {
        logger.info('TextInputComponent: ' +
            this._config.componentId +
            ' => function : _triggerCustomDropdownValidation');
        if (this._config.selectErrors) {
            this._onCustomBlur();
        }
    };
    /**
     * @desc on custom dropdown blur, blur native select to trigger validation
     * @private
     */
    BSSDropdownComponent.prototype._onCustomBlur = function () {
        logger.info('TextInputComponent: ' +
            this._config.componentId +
            ' => function : _onCustomBlur');
        this._$select.trigger('blur');
    };
    /**
     * @desc change dropdown to label if there is some data
     * @private
     */
    BSSDropdownComponent.prototype._convertToLabel = function () {
        logger.info('DropdownComponent: ' +
            this._config.componentId +
            ' => function : _convertToLabel');
        var dropdownDataSplit = this.selectEl$.data('dropname').split('.');
        var dropdownsData = this._config.resultData[dropdownDataSplit[0]][dropdownDataSplit[1]][dropdownDataSplit[2]];
        for (var i = 0; i < dropdownsData.length; i += 1) {
            if (dropdownsData[i].name === dropdownDataSplit[3] &&
                dropdownsData[i].value !== '' &&
                dropdownsData[i].value !== null) {
                var labelConfig = {};
                labelConfig.componentId = this._config.componentId + '_label';
                labelConfig.productId = this._config.productId;
                labelConfig.texts = this._config.texts;
                labelConfig.order = this._config.order;
                labelConfig.componentType = 'LabelComponent';
                labelConfig.text = dropdownsData[i].value;
                labelConfig.testId = "".concat(this._config.testId, "_dropdown-label");
                var labelComp = new BSSLabelComponent(this._entityTemplate, '#' + this._config.labelContainerId, labelConfig, this._eventManager, this._formatter, this._resolution, this._toolbox);
                if (this._config.labelClass) {
                    this._toolbox
                        .$('#' + labelConfig.componentId)
                        .addClass(this._config.labelClass);
                }
                this.destroy();
            }
        }
    };
    /**
     * @desc check that select is hidden - IE10, IE11 or IE Edge
     * @private
     */
    BSSDropdownComponent.prototype._checkHidden = function () {
        logger.info('DropdownComponent: ' +
            this._config.componentId +
            ' => function : _checkHidden');
        if (this._entityTemplate.is('.browser-edge, .browser-safari')) {
            var optionFirst = this._$select.find('option')[0];
            if (optionFirst.hasAttribute('hidden')) {
                this._toolbox.$(optionFirst).removeAttr('hidden');
            }
        }
    };
    /**
     * @desc check that select is disabled and addClass
     * @private
     */
    BSSDropdownComponent.prototype._checkDisabled = function () {
        logger.info('DropdownComponent: ' +
            this._config.componentId +
            ' => function : _checkDisabled');
        if (this._$select.prop('disabled') === true) {
            this._$select.addClass('bss-dropdown--is-disabled');
            this._clearSelect();
        }
        else if (this._$select.hasClass('bss-dropdown--is-disabled')) {
            this._$select.removeClass('bss-dropdown--is-disabled');
            this._$select[0].selectedIndex = 0;
            this._onCustomBlur();
        }
    };
    /**
     * @desc clear select value and all selections from custom fields
     * @private
     */
    BSSDropdownComponent.prototype._clearSelect = function () {
        var _a;
        if (this.customSelectEl.classList.contains('selected') ||
            ((_a = this._$options) === null || _a === void 0 ? void 0 : _a.hasClass(this.selectedClass))) {
            this.customSelectEl.classList.remove('selected');
            this.customSelectContainerEl.classList.remove('bss-dropdown--active');
            this._$select[0].selectedIndex = 0;
            this._$options.removeClass(this.selectedClass);
            this._changeCustomTitle();
        }
    };
    /**
     * @override
     * @private
     */
    BSSDropdownComponent.prototype._prepareData = function () {
        logger.info('DropdownComponent: ' +
            this._config.componentId +
            ' => function : _prepareData');
        this._optionClass = 'bss-dropdown_select-option';
        this._outputObject = this._getValueObject(this._config.configuration);
    };
    /**
     * @desc method override to update label version of select
     * @param {String} publisherName
     * @param {Object} data
     * @override
     * @private
     */
    BSSDropdownComponent.prototype.update = function (publisherName, data) {
        logger.info('DropdownComponent: ' + this._config.componentId + ' => function : update');
        // Component should be is updated by force to previous state because of error from API (revert action).
        // We can indicate the revert state by empty updateTimestamp param.
        var isRevertAction = !data.updateTimestamp;
        if (this._config.changeDropdownDataOnUpdate || isRevertAction) {
            this._prepareData();
            _super.prototype.update.call(this, publisherName, data);
            this._removeDomElement('.bss-dropdown_select-items');
            this._removeDomElement('.bss-dropdown_selected-option');
            this._updateCustomSelectList(false);
        }
        else {
            _super.prototype.update.call(this, publisherName, data);
        }
    };
    /**
     * @desc method returns select values count
     * @return {number}
     * @private
     */
    BSSDropdownComponent.prototype._selectValueListLength = function () {
        logger.info('DropdownComponent: ' +
            this._config.componentId +
            ' => function : _selectValueListLength');
        var length;
        try {
            this._outputObject.optionsTab = this._getMapValues(this._outputObject.dropName, this._config.resultData[this._outputObject.productId].components
                .dropdownComponents);
            length = this._outputObject.optionsTab.values.length;
        }
        catch (e) {
            length = 0;
        }
        return length;
    };
    /**
     * @desc base destroy method
     * @override
     */
    BSSDropdownComponent.prototype.destroy = function () {
        logger.info('DropdownComponent: ' +
            this._config.componentId +
            ' => function : destroy');
        if (typeof this._infohint !== 'undefined') {
            this._infohint.destroy();
        }
        _super.prototype.destroy.call(this);
    };
    return BSSDropdownComponent;
}(BSSAbstractComponent));
export default BSSDropdownComponent;
